import axios from 'axios'

const CustomerMemoService = {
  async get (params = {}) {
    return axios.get('rsm/customer-memos', { params })
  },

  async exports (params = {}) {
    return axios.get('rsm/exports/customer-memos', { params })
  },

  async show (id) {
    return axios.get(`rsm/customer-memos/${id}`)
  },

  async post (params = {}) {
    return axios.post('rsm/customer-memos', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`rsm/customer-memos/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`rsm/customer-memos/${data.id}`, { data })
  }
}

export default CustomerMemoService
